export default __webpack_public_path__ + "static/media/redux.01732ea4.svg";